module.exports = __webpack_public_path__ + "img/6.ec3f4e72.png";